import { Component } from '@angular/core'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { Actions } from '@ngrx/effects'
import { AutomationTypes } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-document-automation-wizard',
  templateUrl: './document-automation-wizard.component.html',
  styleUrls: ['./document-automation-wizard.component.scss'],
})
export class DocumentAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Document
  notifyType: 'signer' | 'user' = 'signer'

  constructor(protected actions: Actions, protected fb: FormBuilder, protected store: Store<any>) {
    super(actions, store, fb)
  }
}
